import React, { useState } from 'react';
import Popup from 'devextreme-react/popup';
import Form, { Item } from 'devextreme-react/form';
import axios from 'axios';
import { MobileEditForm } from '../../components/library/contact-new-form/MobileEditForm';
const apiSendMail = 'https://apicpsc.ximangbimson.com.vn';
type Props = {
  data: any[];
  selectedCa: number;
  selectedDate: Date;
  loadData: () => void;
  setData: React.Dispatch<React.SetStateAction<any[]>>;
};
import { nameserver } from '../../config/nameServer';
import notify from 'devextreme/ui/notify';
import { Center } from 'devextreme-react/cjs/map';
export const MobileCardList = ({
  data,
  selectedCa,
  selectedDate,
  loadData,
  setData,
}: Props) => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [formData, setFormData] = useState<any>(null);
  const userCap = Number(localStorage.getItem('cap'));
  // const [imageFile, setImageFile] = useState<any>(null);
  // const [preview, setPreview] = useState<string>('');
  // const [uploading, setUploading] = useState(false);
  const [historyPopup, setHistoryPopup] = useState(false);

  const [historyData, setHistoryData] = useState<any[]>([]);
  console.log('data:  ', data);

  if (!data || data.length === 0) {
    return <div style={{ padding: 20 }}>Chưa có kết quả kiểm tra</div>;
  }

  const openEditPopup = async (item: any) => {
    console.log('thiet bi', item);
    setFormData({ ...item });
    setPopupVisible(true);
  };

  // gọi api lịch sử tuần tra
  const handleHistory = async (id: number) => {
    try {
      const res = await axios.get(`${nameserver}/api/tuantra_history/${id}`);
      console.log('history', res.data);
      setHistoryData(res.data);

      setHistoryPopup(true);
    } catch (err) {
      console.log(err);
    }
  };

  const onSave = async () => {
    if (!formData?.ID) return;
    console.log('formData mobile ', formData);

    const now = new Date();
    if (formData.KET_QUA == 'Not OK') {
      if (!formData.DE_XUAT?.trim()) {
        notify({
          message: 'Vui lòng nhập đề xuất trước khi lưu',
          type: 'warning',
          displayTime: 2000,
          position: {
            at: 'center',
            my: 'center',
          },
        });
        return;
      }
    }
    const formatted = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(
      now.getHours()
    ).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(
      now.getSeconds()
    ).padStart(2, '0')}`;

    await axios.put(`${nameserver}/api/tuantra/${formData.ID}`, {
      KET_QUA: formData.KET_QUA,
      TRANG_THAI_THIET_BI: formData.TRANG_THAI_THIET_BI,
      DE_XUAT: formData.DE_XUAT,
      ANH: formData.ANH,
      CREATED_BY: localStorage.getItem('fullname'),
      NGAY_SUA: formatted,
    });

    setData((prev: any[]) =>
      prev.map((x) =>
        x.ID === formData.ID
          ? {
              ...x,
              KET_QUA: formData.KET_QUA,
              TRANG_THAI: formData.TRANG_THAI_THIET_BI,
              DE_XUAT: formData.DE_XUAT,
              ANH: formData.ANH,
              CREATED_BY: localStorage.getItem('fullname'),
              NGAY_SUA: formatted,
            }
          : x
      )
    );
    setPopupVisible(false);
    await axios.post(`${nameserver}/api/tuantra_history/${formData.ID}`, {
      KET_QUA: formData.KET_QUA,
      TRANG_THAI_THIET_BI: formData.TRANG_THAI_THIET_BI,
      DE_XUAT: formData.DE_XUAT,
      ANH: formData.ANH,
      CREATED_BY: localStorage.getItem('fullname'),
      NGAY_SUA: formatted,
      CA: formData.CA,
      CAP: formData.CAP,
      TUAN_TRA_NGAY_ID: formData.TUAN_TRA_NGAY_ID,
      NOI_DUNG_ID: formData.NOI_DUNG_ID,
    });
    if (formData.KET_QUA === 'Not OK') {
      const subject = encodeURIComponent(
        `Cảnh báo tuần tra thiết bị Xưởng Clinker`
      );

      const body = encodeURIComponent(
        `Thiết bị: ${formData.TEN_THIET_BI} | ` +
          `Ca: ${formData.CA} | ` +
          `Người kiểm tra: ${localStorage.getItem('fullname')} | ` +
          `Thời gian kiểm tra: ${formatted} | ` +
          `Kết quả: ${formData.KET_QUA} | ` +
          `Trạng thái: ${formData.TRANG_THAI_THIET_BI} | ` +
          `Đề xuất: ${formData.DE_XUAT}`
      );

      await axios.get(`${apiSendMail}/api/Email/send-mail/${subject}/${body}`);
    }
  };

  const isSameDay = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();
  const isEditable = (ca: number, selectedDate: Date) => {
    const now = new Date();
    const d = new Date(selectedDate);

    const hour = now.getHours();

    // CA 1,2 bình thường
    if (ca === 1) {
      if (!isSameDay(now, d)) return false;
      return hour >= 6 && hour < 14;
    }

    if (ca === 2) {
      if (!isSameDay(now, d)) return false;
      return hour >= 14 && hour < 22;
    }

    // 🔥 CA 3 (QUAN TRỌNG)
    if (ca === 3) {
      // ca 3 thuộc 2 ngày khác nhau
      const isNightShift = hour >= 22 || hour < 6;

      return isNightShift;
    }

    return false;
  };
  // const handleImageChange = async (e: any) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   setPreview(URL.createObjectURL(file));

  //   const form = new FormData();
  //   form.append('file', file);

  //   setUploading(true);

  //   const res = await axios.post('${nameserver}/api/upload', form, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   });

  //   setUploading(false);

  //   // Lưu URL ảnh vào formData
  //   setFormData({
  //     ...formData,
  //     ANH: res.data.url,
  //   });
  // };
  const getSafeUrl = (url: string) => {
    if (!url) return '';

    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    return nameserver.replace(/\/$/, '') + '/' + url.replace(/^\//, '');
  };
  return (
    <>
      <div style={{ paddingBottom: '50px' }}>
        {data
          .filter((x) => x.CA === selectedCa)
          .map((item, index) => {
            const value = item.KET_QUA;

            return (
              <div
                key={item.ID}
                style={{
                  background:
                    value === 'OK'
                      ? '#e8f5e9'
                      : value === 'Not OK'
                      ? '#ffebee'
                      : '#ece8e4',
                  padding: 14,
                  borderRadius: 12,
                  marginBottom: 12,
                  boxShadow: '0 3px 8px rgba(0,0,0,0.08)',
                  lineHeight: 1.4,
                  // minHeight: '40vh',
                  // paddingBottom: '100px'
                }}
              >
                <div
                  style={{
                    fontWeight: 800,
                    fontSize: 18,
                    color: '#d81dcf',
                    padding: '6px 10px',
                    borderRadius: 8,
                    marginBottom: 8,
                    textAlign: 'center'
                  }}
                >
                  {item.TEN_THIET_BI}
                </div>
                <div>
                  <b>Bộ phận: </b>
                  {item.TEN_BO_PHAN}
                </div>
                {/* <div>{item.NOI_DUNG_KIEM_TRA}</div> */}

                <div>
                  <b>Người Kiểm Tra: </b>
                  {item.CREATED_BY}
                </div>
                <div>
                  <b>Thời gian KT: </b>
                  {item.NGAY_SUA
                    ? new Date(item.NGAY_SUA).toLocaleString('vi-VN')
                    : ''}
                </div>
                <div>
                  <b>Trạng thái: </b>
                  {item.TRANG_THAI}
                </div>
                <div>
                  <b>Đề xuất: </b>
                  {item.DE_XUAT}
                </div>
                <div style={{ display: 'flex', gap: 12 }}>
                  <div>
                    <b>Ca {selectedCa}</b>
                  </div>
                  <div>
                    <b>Cấp {item.CAP}</b>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: 8,
                    marginTop: 6,
                  }}
                >
                  {/* Nút kiểm tra */}
                  {item.CAP === userCap ? (
  <button
    onClick={() => {
      if (!isEditable(selectedCa, selectedDate)) {
        notify('Ngoài ca, không được sửa', 'warning', 2000);
        return;
      }

      openEditPopup(item);
    }}
    style={{
      flex: 1,
      padding: '8px 10px',
      border: 'none',
      borderRadius: 10,

      background:
        value === 'OK'
          ? 'linear-gradient(135deg,#dcfce7,#bbf7d0)'
          : value === 'Not OK'
          ? 'linear-gradient(135deg,#fee2e2,#fecaca)'
          : 'linear-gradient(135deg,#fef3c7,#fde68a)',

      color:
        value === 'OK'
          ? '#15803d'
          : value === 'Not OK'
          ? '#dc2626'
          : '#92400e',

      fontWeight: 600,
      cursor: 'pointer',
      fontSize: 13,

      boxShadow:
        value === 'OK'
          ? '0 2px 6px rgba(34,197,94,0.2)'
          : value === 'Not OK'
          ? '0 2px 6px rgba(239,68,68,0.2)'
          : '0 2px 6px rgba(245,158,11,0.25)',

      transition: 'all 0.2s ease',
    }}
  >
    {value === 'OK'
      ? '✅ OK'
      : value === 'Not OK'
      ? '❌ Not OK'
      : '🟡 Chưa KT'}
  </button>
) : (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '8px 12px',
      borderRadius: 10,
      fontSize: 13,
      fontWeight: 700,

      background:
        value === 'OK'
          ? '#dcfce7'
          : value === 'Not OK'
          ? '#fee2e2'
          : '#fef3c7',

      color:
        value === 'OK'
          ? '#15803d'
          : value === 'Not OK'
          ? '#dc2626'
          : '#92400e',
    }}
  >
    {value === 'OK'
      ? '✅ OK'
      : value === 'Not OK'
      ? '❌ Not OK'
      : '🟡 Chưa KT'}
  </div>
)}

                  {/* Nút lịch sử */}
                  <button
                    onClick={() => handleHistory(item.ID)}
                    style={{
                      flex: 1,

                      padding: '8px 10px',

                      border: 'none',

                      borderRadius: 10,

                      background: 'linear-gradient(135deg,#2563eb,#1d4ed8)',

                      color: '#fff',

                      fontWeight: 600,

                      cursor: 'pointer',

                      fontSize: 13,

                      boxShadow: '0 2px 6px rgba(37,99,235,0.25)',

                      transition: 'all 0.2s ease',
                    }}
                  >
                    📜 Lịch sử
                  </button>
                </div>
              </div>
            );
          })}
      </div>
      <Popup
        visible={historyPopup}
        onHiding={() => setHistoryPopup(false)}
        title='Lịch sử kiểm tra'
        width='100%'
        height='100%'
        showCloseButton={true}
      >
        <div
          style={{
            padding: 12,
            background: '#f5f5f5',
            minHeight: '100%',
            overflowY: 'auto',
          }}
        >
          {historyData.length === 0 && (
            <div
              style={{
                textAlign: 'center',
                marginTop: 30,
              }}
            >
              Chưa có lịch sử tuần tra
            </div>
          )}

          {historyData.map((item, index) => (
            <div
              key={index}
              style={{
                background: '#fff',
                borderRadius: 12,
                padding: 14,
                marginBottom: 14,
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              }}
            >
              <p>
                <b>Kết quả:</b>{' '}
                <span
                  style={{
                    fontWeight: 700,
                    color: item.KET_QUA === 'OK' ? 'green' : 'red',
                  }}
                >
                  {item.KET_QUA}
                </span>
              </p>
              <p>
                <b>Trạng thái:</b> {item.TRANG_THAI}
              </p>

              <p>
                <b>Đề xuất:</b> {item.DE_XUAT || 'Không có'}
              </p>

              <p>
                <b>Người kiểm tra:</b> {item.CREATED_BY}
              </p>
              <p>
                <b>Ngày giờ kiểm tra:</b>{' '}
                {item.NGAY_SUA
                  ? new Date(item.NGAY_SUA).toLocaleString('vi-VN')
                  : ''}
              </p>

              {item.ANH && (
                <img
                  src={getSafeUrl(item.ANH)}
                  style={{
                    width: '100%',
                    borderRadius: 10,
                    marginTop: 10,
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </Popup>
      <Popup
        visible={popupVisible}
        onHiding={() => setPopupVisible(false)}
        title='Sửa tuần tra'
        fullScreen={true}
        showCloseButton={true}
        dragEnabled={false}
        hideOnOutsideClick={true}
      >
        <div style={{ height: '100%', overflowY: 'auto', padding: 10 }}>
          {formData && (
            <div>
              <MobileEditForm
                initData={formData}
                onDataChanged={(d) => setFormData(d)}
              />

              <div
                style={{
                  marginTop: 20,
                  marginBottom: 50,
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: 12,
                }}
              >
                <button
                  onClick={() => setPopupVisible(false)}
                  style={{
                    padding: '10px 20px',
                    borderRadius: 8,
                    border: '1px solid #ccc',
                    backgroundColor: '#fff',
                    cursor: 'pointer',
                    fontWeight: 500,
                  }}
                >
                  Hủy
                </button>

                <button
                  style={{
                    padding: '10px 20px',
                    borderRadius: 8,
                    border: 'none',
                    backgroundColor: !isEditable(selectedCa, selectedDate)
                      ? '#bdbdbd'
                      : '#1976d2',
                    color: '#fff',
                    cursor: !isEditable(selectedCa, selectedDate)
                      ? 'not-allowed'
                      : 'pointer',
                    fontWeight: 600,
                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                    transition: '0.2s',
                  }}
                  onClick={onSave}
                  disabled={!isEditable(selectedCa, selectedDate)}
                >
                  Lưu
                </button>
              </div>
            </div>
          )}
        </div>
      </Popup>
    </>
  );
};
